import { render, staticRenderFns } from "./MyPicture.vue?vue&type=template&id=a0a79a3e&scoped=true"
import script from "./MyPicture.vue?vue&type=script&lang=js"
export * from "./MyPicture.vue?vue&type=script&lang=js"
import style0 from "./MyPicture.vue?vue&type=style&index=0&id=a0a79a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a79a3e",
  null
  
)

export default component.exports